import * as React from 'react'

import { Box, Icon, Table, Text } from '@factorialco/deprecated-design-system'

import { Selectable } from 'modules/core/components/DataTable/core/types'
import type { HeadCell } from 'modules/core/components/DataTable/types'
import i18n from 'modules/core/lib/i18n'

interface Props<S extends string> {
  header: HeadCell<S>[]
  selectable?: Selectable
}

function Error<S extends string>({ header, selectable }: Props<S>) {
  const colSpan =
    header.reduce((acc, { colSpan }) => acc + (colSpan ?? 1), 0) + (selectable ? 1 : 0)

  return (
    <Table.Body>
      <Table.Row>
        <Table.Cell colSpan={colSpan}>
          <Box
            width="full"
            padding="s16"
            flexDirection="column"
            gap="s12"
            alignItems="center"
            justifyContent="center"
          >
            <Icon.Large icon="sign-post" />
            <Text.Header2>{i18n.t('common.crash.title')}</Text.Header2>
            <Text.Normal>{i18n.t('common.crash.retry')}</Text.Normal>
          </Box>
        </Table.Cell>
      </Table.Row>
    </Table.Body>
  )
}

export default Error
